import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';

import logo from 'assets/images/logo192.png';

// ==============================|| LOGO  ||============================== //

const Logo = ({ width = '50', height = '50' }) => {
	const theme = useTheme();

	return <img src={logo} alt="Varthana" width={width} height={height} />;
};

Logo.propTypes = {
	width: PropTypes.string,
	height: PropTypes.string,
};

export default Logo;
